/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResult
 */
export interface RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResult {
    /**
     * 
     * @type {number}
     * @memberof RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResult
     */
    totalInternalProjects?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResult
     */
    totalInternalNeedsReviewEntries?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResult
     */
    totalInternalUpdatedEntries?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResult
     */
    totalInternalApprovedEntries?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResult
     */
    totalExternalProjects?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResult
     */
    totalExternalNeedsReviewEntries?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResult
     */
    totalExternalUpdatedEntries?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResult
     */
    totalExternalApprovedEntries?: number;
}

/**
 * Check if a given object implements the RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResult interface.
 */
export function instanceOfRevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResult(value: object): value is RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResult {
    return true;
}

export function RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResultFromJSON(json: any): RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResult {
    return RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResultFromJSONTyped(json, false);
}

export function RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResult {
    if (json == null) {
        return json;
    }
    return {
        
        'totalInternalProjects': json['totalInternalProjects'] == null ? undefined : json['totalInternalProjects'],
        'totalInternalNeedsReviewEntries': json['totalInternalNeedsReviewEntries'] == null ? undefined : json['totalInternalNeedsReviewEntries'],
        'totalInternalUpdatedEntries': json['totalInternalUpdatedEntries'] == null ? undefined : json['totalInternalUpdatedEntries'],
        'totalInternalApprovedEntries': json['totalInternalApprovedEntries'] == null ? undefined : json['totalInternalApprovedEntries'],
        'totalExternalProjects': json['totalExternalProjects'] == null ? undefined : json['totalExternalProjects'],
        'totalExternalNeedsReviewEntries': json['totalExternalNeedsReviewEntries'] == null ? undefined : json['totalExternalNeedsReviewEntries'],
        'totalExternalUpdatedEntries': json['totalExternalUpdatedEntries'] == null ? undefined : json['totalExternalUpdatedEntries'],
        'totalExternalApprovedEntries': json['totalExternalApprovedEntries'] == null ? undefined : json['totalExternalApprovedEntries'],
    };
}

export function RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResultToJSON(json: any): RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResult {
    return RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResultToJSONTyped(json, false);
}

export function RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResultToJSONTyped(value?: RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalInternalProjects': value['totalInternalProjects'],
        'totalInternalNeedsReviewEntries': value['totalInternalNeedsReviewEntries'],
        'totalInternalUpdatedEntries': value['totalInternalUpdatedEntries'],
        'totalInternalApprovedEntries': value['totalInternalApprovedEntries'],
        'totalExternalProjects': value['totalExternalProjects'],
        'totalExternalNeedsReviewEntries': value['totalExternalNeedsReviewEntries'],
        'totalExternalUpdatedEntries': value['totalExternalUpdatedEntries'],
        'totalExternalApprovedEntries': value['totalExternalApprovedEntries'],
    };
}

